import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import BuyPlan from "./PlanPurchase/BuyPlan";
import { useEffect } from "react";

const LandingPage = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T539001XT0B");


  useEffect(() => {
    /* ---------- LOAD CSS ---------- */
    const cssFiles = [
      "/landing/css/font-awesome-all.css",
      "/landing/css/flaticon.css",
      "/landing/css/owl.css",
      "/landing/css/bootstrap.css",
      "/landing/css/jquery.fancybox.min.css",
      "/landing/css/animate.css",
      "/landing/css/nice-select.css",
      "/landing/css/elpath.css",
      "/landing/css/color.css",
      "/landing/css/style.css",
      "/landing/css/module-css/banner.css",
      "/landing/css/module-css/feature.css",
      "/landing/css/module-css/service.css",
      "/landing/css/module-css/about.css",
      "/landing/css/module-css/benefits.css",
      "/landing/css/module-css/estimate.css",
      "/landing/css/module-css/chooseus.css",
      "/landing/css/module-css/testimonial.css",
      "/landing/css/module-css/faq.css",
      "/landing/css/module-css/awards.css",
      "/landing/css/module-css/responsive.css",
    ];

    const loadedLinks = cssFiles.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });

    /* ---------- LOAD JS ---------- */
    const jsFiles = [
      "/landing/js/jquery.js",
      "/landing/js/bootstrap.min.js",
      "/landing/js/owl.js",
      "/landing/js/wow.js",
      "/landing/js/jquery.fancybox.js",
      "/landing/js/appear.js",
      "/landing/js/isotope.js",
      "/landing/js/jquery.nice-select.min.js",
      "/landing/js/nav-tool.js",
      "/landing/js/tilt.jquery.js",
      "/landing/js/script.js",
    ];

    const loadedScripts = jsFiles.map((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      document.body.appendChild(script);
      return script;
    });

    /* ---------- CLEANUP ---------- */
    return () => {
      loadedLinks.forEach((link) => document.head.removeChild(link));
      loadedScripts.forEach((script) =>
        document.body.removeChild(script)
      );
    };
  }, []);

  return (
    <div className="overflow-x-hidden">
      <div className="min-h-screen text-slate-900 font-sans">

        {/* HERO SECTION */}
        {/* <div
          className="text-white relative mb-[-60px] z-0"
          style={{
            height: "600px",
            backgroundImage: "url(/assets/img/main-2.png)",
            backgroundSize: "cover",
            backgroundPosition: "left bottom",
          }}
        >
          <div className="max-w-7xl mx-auto px-4 lg:px-8 h-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch h-full">
              <div className="space-y-6 text-left flex flex-col justify-center relative z-10">
                <a href='/'>
                  <img src="http://swasthopd.com/assets/img/logo/swastha-opd-logo-1.png" alt='' className='w-[180px]' />
                </a>
                <h1 className="font-semibold !leading-[60px] pt-[40px] pb-[0px] text-3xl sm:text-4xl lg:text-5xl max-md:!leading-[50px]">
                  Comprehensive Family
                  <br />
                  Healthcare.
                  <br />
                  Simple, Affordable,
                  <br />
                  Trusted.
                </h1>

                <div className="flex flex-wrap gap-4 pt-2">
                  <a href="#pricing" className="px-6 py-3 rounded-full bg-white text-[#104A52] text-sm sm:text-base font-semibold shadow-md hover:bg-slate-100 transition">
                    View Plans
                  </a>
                  <a href="#how-it-works" className="px-6 py-3 rounded-full border border-white/70 text-sm sm:text-base font-semibold text-white hover:bg-white/10 transition">
                    How It Works
                  </a>
                </div>
                <div className='w-full h-[60px]'></div>
              </div>
            </div>
          </div>
        </div> */}

        <header className="main-header header-style-one">
          {/* header-top */}
          {/* header-upper */}
          <div className="header-upper !bg-[#104a52]">
            <div className="container-fluid">
              <div className="upper-inner">
                <div className='flex gap-4'>
                  <a href="/">
                    <img src="https://swasthopd.com/assets/img/logo/swastha-opd-logo-1.png" width="180" alt="" />
                  </a>
                  <ul className="social-links md:!hidden">
                    <li>
                      <a href="https://www.facebook.com/share/17MXed7usZ/" target="new">
                        <i className="fab fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/AshwiniMeh25150?t=phuRWTZoqa_RBRFAjT5pHw&s=09&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnOIQli_i9O6HonlNZHnjvD38S2zZWB4PulXoAfaePAOLqgLfSbwDl8063cBY_aem_C03ZKGke_shBPOXV3Hp4ig" target="new">
                        <i className="fab fa-twitter" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/swasthopd/" target="new">
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="right-column">
                  <ul className="info-list">
                    <li>
                      <div className="icon-box">
                        <img src="landing/images/icons/icon-4.png" className='invert-[1]' alt="" />
                      </div>
                      <span className="!text-white">Contact Mail</span>
                      <h5>
                        <a href="mailto:hello@swasthopd.com" className='!text-white'>hello@swasthopd.com</a>
                      </h5>
                    </li>
                  </ul>
                  <ul className="social-links max-md:!hidden">
                    <li>
                      <a href="https://www.facebook.com/share/17MXed7usZ/" target="new">
                        <i className="fab fa-facebook-f" />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/AshwiniMeh25150?t=phuRWTZoqa_RBRFAjT5pHw&s=09&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnOIQli_i9O6HonlNZHnjvD38S2zZWB4PulXoAfaePAOLqgLfSbwDl8063cBY_aem_C03ZKGke_shBPOXV3Hp4ig" target="new">
                        <i className="fab fa-twitter" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/swasthopd/" target="new">
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>


        {/* banner-section */}
        {/* <section className="banner-section p_relative">
          <div
            className="bg-layer !bg-[#f1fff1]"
            style={{ backgroundImage: "url(landing/images/banner/banner-1.jpg)" }}
          />
          <div
            className="pattern-layer"
          />
          <div className="auto-container">
            <div className="rwo clearfix">
              <div className="col-xl-5 col-lg-12 col-md-12 offset-xl-7 content-column">
                <div className="content-box">
                  <span className="upper-text">Trusted Company</span>
                  <h2>Make Your Family Protected?</h2>
                  <h3 className='max-md:!text-[18px]'>Get Your Health Plan Today</h3>
                  <section className="mb-4">
                    <iframe className="aspect-video w-full rounded-[20px] max-md:w-[75%]" src="landing/video.mp4" ></iframe>
                  </section>
                  <div className="info-box">
                    <div className="icon-box">
                      <img src="landing/images/icons/icon-7.png" alt="" />
                    </div>
                    <p>
                      Get A Custom Quote Today <br />
                      Call Now : <a href="tel:18004567890">1800 309 2740</a>
                    </p>
                  </div>
                  <div className="btn-box">
                    <a href="#pricing" className="theme-btn btn-one">
                      <span>Discover More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* banner-section end */}


        {/* Hero Feature Cards */}
        {/* <div className="relative z-20 max-w-6xl mx-auto px-4 lg:px-8 pb-8 lg:pb-12">
          <div className="grid lg:grid-cols-4 grid-cols-2 items-center gap-3 sm:gap-4">
            {[
              "Family of 4",
              "24/7 Doctor",
              "Medicine Discounts",
              "Diagnostic Savings",
            ].map((label, i) => (
              <div
                key={label}
                className="bg-white rounded-2xl shadow-md flex items-center max-md:block gap-2.5 sm:gap-3 !py-[30px] sm:py-3.5 px-2.5 sm:px-4 relative z-20"
              >
                <div className="w-[60px] h-[60px] rounded-xl bg-[#f7f8fc] flex items-center justify-center text-lg sm:text-xl shrink-0">
                  {i === 0 && <i className="fa-solid fa-users text-[30px]"></i>}
                  {i === 1 && <i class="fa-solid fa-briefcase-medical text-[30px]"></i>}
                  {i === 2 && <i class="fa-solid fa-pills text-[30px]"></i>}
                  {i === 3 && <i class="fa-solid fa-microscope text-[30px]"></i>}
                </div>
                <p className="!text-[20px] mb-0 sm:text-sm font-semibold text-slate-800 max-md:mt-3">
                  {label}
                </p>
              </div>
            ))}
          </div>
        </div> */}



        {/* Hero Section Redesigned */}
        <div className="overflow-x-hidden">
          <section className="pt-12 bg-[#f1fff1] sm:pt-16">
            <div className="px-4 mx-auto max-w-7xl max-md:w-full sm:px-6 lg:px-8">
              <div className="max-w-[80%] mx-auto text-center max-md:max-w-full">
                <div className="subtitle text-uppercase mb-3 text-[14px]">Smart Plans for Family Needs
                </div>
                <h1
                  className="mt-4 text-[50px] leading-[1.2em] font-bold text-black max-md:text-[36px]">
                  Affordable OPD & Wellness Plans <br className='max-md:hidden'/>for Complete Well-Being
                </h1>

                <p className='my-4 text-black font-medium text-[18px]'>Access doctor consultations, diagnostics, pharmacy benefits, and preventive wellness services under one simple plan. Designed to support your family’s everyday healthcare—without the burden of high medical expenses.</p>

                <div className="btn-box mt-[40px]">
                  <a href="#pricing" className="theme-btn btn-one">
                    <span>Discover More</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="pb-12 mt-[100px] bg-white max-md:px-[15px]">
              <div className="relative">
                <div className="absolute inset-0 h-2/3 bg-[#f1fff1]"></div>
                <div className="relative mx-auto">
                  <div className="lg:max-w-7xl lg:mx-auto flex justify-center items-center">
                    <div className="video-wrapper mx-width">
                      <video
                        className="w-full rounded-[20px]"
                        controls
                        preload="metadata"
                        poster="/landing/benefits.jpg"
                      >
                        <source src="/landing/video.mp4" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>



        {/* ======= How it works =======*/}
        <section className="section howitworks__v1 pt-[10px] pb-[100px] !bg-[#ffffff]" id="how-it-works">
          <div className="container-fluid">
            <div className="row mb-5">
              <div className="col-md-6 text-center mx-auto">
                <span
                  className="subtitle text-uppercase mb-3 text-[14px]"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  How it works
                </span>
                <h2 className="text-[32px] mb-3" data-aos="fade-up" data-aos-delay={100}>
                  How It Works
                </h2>
                <p className="m" data-aos="fade-up" data-aos-delay={200}>
                  Get easy, cashless healthcare with SwasthOPD.
                </p>
              </div>
            </div>
            <div className='container-fluid mx-auto'>
              <div className='flex gap-[30px] justify-center max-md:flex-col'>
                <div className="video-wrapper">
                  <video
                    className="w-full rounded-[20px]"
                    controls
                    preload="metadata"
                    poster="/landing/buy.jpg"
                  >
                    <source src="/landing/how-to-buy.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="video-wrapper">
                  <video
                    className="w-full rounded-[20px]"
                    controls
                    preload="metadata"
                    poster="/landing/login.jpg"
                  >
                    <source src="/landing/how-to-login.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="video-wrapper">
                  <video
                    className="w-full rounded-[20px]"
                    controls
                    preload="metadata"
                    poster="/landing/use.jpg"
                  >
                    <source src="/landing/how-to-use.mp4" type="video/mp4" />
                  </video>
                </div>


              </div>
            </div>
            <div className="btn-box mt-5 flex justify-center w-full">
              <a href="#pricing" className="theme-btn btn-one">
                <span>Choose Plan</span>
              </a>
            </div>
          </div>
        </section>
        {/* End How it works*/}

        {/* TRUSTED BY */}
        <section className="py-10 lg:py-14 !bg-[#f1fff1]">
          <div className="max-w-6xl mx-auto px-4 lg:px-8">
            <div className="row mb-5">
              <div className="col-md-6 text-center mx-auto">
                <span
                  className="subtitle text-uppercase mb-3 text-[14px]"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Trust
                </span>
                <h2 className="text-[32px] mb-3" data-aos="fade-up" data-aos-delay={100}>
                  Family Healthcare You Can Trust
                </h2>
                <p className="m" data-aos="fade-up" data-aos-delay={200}>
                  Trusted by families for delivering licensed medical support, <br className='max-md:hidden' />nationwide coverage, and everyday health savings.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-5  mb-[60px]">
              {[
                "Licensed Doctors",
                "PAN India Network",
                "Medicine Savings",
                "Diagnostic Discounts",
              ].map((label, i) => (
                <div
                  key={label}
                  className="relative bg-[#ffffff] border border-[#f7fcfd] rounded-2xl shadow-md pt-[30px] pb-[10px] px-3 sm:px-4 flex flex-col items-center text-center"
                >
                  <div className="w-12 h-12 sm:w-[60px] sm:h-[60px] rounded-2xl bg-[#f1fff1] flex items-center justify-center mb-3 text-xl sm:text-2xl">
                    {i === 0 && <i class="fa-solid fa-user-doctor text-[30px]"></i>}
                    {i === 1 && <i class="fa-solid fa-hospital-user text-[30px]"></i>}
                    {i === 2 && <i class="fa-solid fa-capsules text-[30px]"></i>}
                    {i === 3 && <i class="fa-solid fa-stethoscope text-[30px]"></i>}
                  </div>
                  <p className="text-[22px] font-semibold text-slate-800 leading-snug">
                    {label}
                  </p>
                  <div className="w-[60%] h-[6px] rounded-full bg-[#104A52] absolute bottom-[-3px]" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* PRICING / PLANS */}
        <section className="py-[100px] bg-[#ffffff] max-md:px-[15px]" id="pricing">
          <div className="row mb-5">
            <div className="col-md-6 text-center mx-auto">
              <span
                className="subtitle text-uppercase mb-3 text-[14px]"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Pricing
              </span>
              <h2 className="text-[32px] mb-3" data-aos="fade-up" data-aos-delay={100}>
                Plans Available For You
              </h2>
              <p className="m" data-aos="fade-up" data-aos-delay={200}>
                Affordable plans designed to fit your family.
              </p>
            </div>
          </div>
          <div className="max-w-6xl mx-auto md:px-4 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-stretch">
              {/* Standard Card */}
              <div className="bg-[#f4feff] rounded-[24px] md:shadow-xl p-5 sm:p-7 flex flex-col justify-between h-full">
                <div>
                  <h3 className="text-[24px] font-semibold mb-3">
                    Swasth Pro
                  </h3>
                  <p className="text-[#104A52] text-[40px] font-semibold">
                    ₹150
                    <span className="text-xs sm:text-base font-medium">
                      + GST
                    </span>
                  </p>

                  <ul className="mt-4 space-y-2 text-xs sm:text-sm text-slate-700 flex flex-col gap-[10px] pl-0">
                    {[
                      "3 Credits on Tele Doctor Consultation",
                      "Upto 20% Off on Prescribed Pharmacy",
                      "Upto 50% Off on Diagnostics",
                      <div><span className='font-bold'>Free </span>₹1 Lakh Personal Accidental Cover for primary member</div>,
                    ].map((item, i) => (
                      <li key={item} className="flex items-start gap-[16px]">
                        <span className="mt-[3px] inline-block w-3.5 h-3.5 rounded-full border-2 border-[#104A52]">
                          {i === 0 && <i class="fa-solid fa-check text-[20px]"></i>}
                          {i === 1 && <i class="fa-solid fa-check text-[20px]"></i>}
                          {i === 2 && <i class="fa-solid fa-check text-[20px]"></i>}
                          {i === 3 && <i class="fa-solid fa-check text-[20px]"></i>}
                        </span>
                        <span className='text-[20px] font-normal leading-[1.4em]'>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button className="mt-6 w-full py-3 rounded-full bg-[#104A52] text-white font-semibold text-sm shadow-md hover:bg-[#56b43c] transition"
                  onClick={() => {
                    setPlanCode("OPDBasicCare");
                    setOpenPopup(true);
                  }}>
                  Choose Plan
                </button>

              </div>

              {/* Premium Card */}
              <div className="relative bg-[#104A52] text-white rounded-[24px] shadow-2xl p-5 sm:p-7 flex flex-col justify-between h-full">
                <div>
                  <span className="absolute -top-3 right-4 sm:right-6 bg-[#56b43c] text-white text-[10px] sm:text-xs font-semibold py-1.5 px-3 rounded-full shadow-md">
                    Most Popular
                  </span>

                  <h3 className="text-[24px] font-semibold mb-3 text-white">
                    Swasth Max
                  </h3>
                  <p className="text-[40px] text-white font-semibold">
                    ₹250
                    <span className="text-xs sm:text-base font-medium">
                      + GST
                    </span>
                  </p>

                  <ul className="mt-4 space-y-2 text-xs sm:text-sm text-teal-50 flex flex-col gap-[10px] pl-0">
                    {[
                      "Unlimited on Tele Doctor Consultation",
                      "Upto 20% Off on Prescribed Pharmacy",
                      "Upto 50% Off on Diagnostics",
                      <div><span className='font-bold'>Free </span>₹2 Lakhs Personal Accidental Cover for primary member</div>,
                    ].map((item, i) => (
                      <li key={item} className="flex items-start gap-[16px]">
                        <span className="mt-[3px] inline-block w-3.5 h-3.5 rounded-full border-2 border-white">
                          {i === 0 && <i class="fa-solid fa-check text-[20px]"></i>}
                          {i === 1 && <i class="fa-solid fa-check text-[20px]"></i>}
                          {i === 2 && <i class="fa-solid fa-check text-[20px]"></i>}
                          {i === 3 && <i class="fa-solid fa-check text-[20px]"></i>}
                        </span>
                        <span className='text-[20px] font-normal leading-[1.4em]'>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button className="mt-6 w-full py-3 rounded-full bg-[#ffffff] text-[#104A52] font-semibold text-sm shadow-md hover:text-white hover:bg-[#56b43c] transition"
                  onClick={() => {
                    setPlanCode("OPDStandardCare");
                    setOpenPopup(true);
                  }}>
                  Choose Plan
                </button>
              </div>
            </div>
          </div>
        </section>


        {/* TESTIMONIALS */}
        <section className="py-10 lg:py-14 !bg-[#f1fff1]">
          <div className="max-w-6xl mx-auto px-4 lg:px-8">
            <div className="row mb-5">
              <div className="col-md-6 text-center mx-auto">
                <span
                  className="subtitle text-uppercase mb-3 text-[14px]"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Testimonials
                </span>
                <h2 className="text-[32px] mb-3" data-aos="fade-up" data-aos-delay={100}>
                  Voices of Our Happy Members
                </h2>
                <p className="m" data-aos="fade-up" data-aos-delay={200}>
                  Real stories from families who trust us for <br />their everyday healthcare needs.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {[
                { name: "Karan Singh", location: "Chandigarh", img: <img src="assets/img/karan.png" alt="not found" />, text: "I’m impressed by their dedication to making healthcare affordable. Their OPD plans fit perfectly within my budget, without compromising quality." },
                { name: "Sneha Gupta", location: "Jaipur", img: <img src="assets/img/sneha.png" alt="not found" />, text: "Their OPD coverage is a lifesaver. I’ve saved so much on regular doctor visits and diagnostic tests. Thank you for this amazing service!" },
                { name: "Vikram Mehta", location: "Bangalore", img: <img src="assets/img/vikram.png" alt="not found" />, text: "I travel a lot for work, and Swasth OPD plans have given me peace of mind no matter where I am. Truly reliable and convenient." },
                { name: "Pooja Verma", location: "Delhi", img: <img src="assets/img/pooja.png" alt="not found" />, text: "From consultations to diagnostics, everything is hassle-free. It’s so convenient, especially when you have kids at home." },
              ].map((user) => (
                <div
                  key={user.name}
                  className="bg-white rounded-2xl border border-[#cfe9ee] shadow-md p-4 sm:p-5"
                >
                  <div className="flex items-center justify-between mb-3 gap-3 max-md:block">
                    <div className="flex items-center gap-3">
                      <div className="w-[60px] sm:h-[60px] rounded-full overflow-hidden flex items-center justify-center shrink-0">
                        {user.img}
                      </div>
                      <div>
                        <p className="text-[20px] mb-0 font-semibold text-[#0f172A]">{user.name}</p>
                        <p className="text-[14px] font-medium text-[#0f172A]">
                          {user.location}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center text-[30px] text-yellow-400">
                      {"★★★★★".split("").map((s, i) => (
                        <span key={i}>{s}</span>
                      ))}
                    </div>
                  </div>
                  <p className="text-[18px] text-slate-600 leading-relaxed">
                    {user.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="bg-gray overflow-hidden">
          <div className="container">
            <div className="f-items" style={{ padding: "80px 0" }}>
              <div className="row">
                <div className="col-lg-6 col-md-6 footer-item pr-30 pr-md-15 pr-xs-15">
                  <div className="f-item address">
                    <a className="navbar-brand" href="/">
                      <img
                        src="/assets/img/logo/swastha-opd-logo-1.png"
                        className="logo"
                        alt="Logo"
                        style={{ height: 80 }}
                      />
                    </a>
                    <p className="w-400px">
                      At Swasth OPD, we are committed to revolutionizing healthcare by bridging the gap between wellness and accessibility. As a leading health and wellness broker, we specialize in offering tailor-made health plans that cater to businesses and individuals alike. —{" "}
                      <strong style={{ color: "#000000" }}>
                        you gain a trusted partner
                      </strong>
                    </p>
                    <ul className="contact-address">
                      <li>
                        <p>Our Location</p>
                        <h4 className="w-400px">
                          642/1 Plot 30, Najafgarh Road Ind Area, West
                          Delhi-110015
                        </h4>
                      </li>
                      <li>
                        <p>Contact Number</p>
                        <h4 className="w-400px">
                          1800 309 2740
                        </h4>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 footer-item">
                  <div className="f-item link">
                    <h4 className="widget-title">Quick Links</h4>
                    <ul className="pl-0">
                      <li>
                        <Link to="/" className="no-underline">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/plans"
                          className="no-underline"
                        >
                          Plans
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" className="no-underline">
                          Contact
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 footer-item">
                  <div className="f-item link">
                    <h4 className="widget-title">Our Services</h4>
                    <ul className="pl-0">
                      <li>
                        <Link to="/term-of-use" className="no-underline">
                          Terms Of Use
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy" className="no-underline">
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/cancellation-policy" className="no-underline">
                          Cancellation Policy
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/shipping-delivery-policy"
                          className="no-underline"
                        >
                          Shipping and Delivery Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Start Footer Bottom */}
          <div className="footer-bottom bg-[#1F2B38] text-light">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <p>
                    © Copyright {new Date().getFullYear()}. All Rights Reserved by{" "}
                    <a href="#top">Swasth OPD</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* End Footer Bottom */}
        </footer>

        <BuyPlan
          planCode={planCode}
          tenantId={tenantId}
          showPopUp={openPopup}
          setShowPopUp={setOpenPopup}
        />
      </div>
    </div>
  )
}

export default LandingPage